import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1.705c5.686 0 10.295 4.609 10.295 10.295S17.686 22.295 12 22.295 1.705 17.686 1.705 12 6.314 1.705 12 1.705zm0 1.5a8.795 8.795 0 1 0 0 17.59 8.795 8.795 0 0 0 0-17.59zm0 4.636a.75.75 0 0 1 .75.75v3.099l4.041 4.042a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0L11.47 12.53l-.064-.072A.75.75 0 0 1 11.25 12l.004.076a.754.754 0 0 1-.003-.047L11.25 12V8.59a.75.75 0 0 1 .75-.75z' />
  </svg>
);
